import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/admin-img/light_delete-outline.svg'


const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "admin-mid-container" }
const _hoisted_3 = {
  class: "admin-custom-row admin-page-row",
  id: "leftMenuSlideBox"
}
const _hoisted_4 = { class: "admin-right-sidebar-in" }
const _hoisted_5 = { class: "admin-right-sidebar-in-top" }
const _hoisted_6 = { class: "admin-custom-row" }
const _hoisted_7 = { class: "admin-right-sidebar-in-top-left" }
const _hoisted_8 = { class: "admin-page-type-links" }
const _hoisted_9 = { class: "admin-right-sidebar-in-top-right" }
const _hoisted_10 = { class: "admin-right-sidebar-in-top-right-top" }
const _hoisted_11 = { class: "admin-search-box" }
const _hoisted_12 = { class: "admin-add-btn" }
const _hoisted_13 = {
  key: 0,
  class: "admin-right-sidebar-in-top-right-btm"
}
const _hoisted_14 = { class: "tags" }
const _hoisted_15 = { class: "delete-all-btn-link" }
const _hoisted_16 = {
  key: 0,
  class: "white-bg-border add-new-section"
}
const _hoisted_17 = { class: "add-banner-image-section" }
const _hoisted_18 = { class: "email-template-form-row" }
const _hoisted_19 = { class: "add-banner-image-box" }
const _hoisted_20 = { class: "admin-input-field" }
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_23 = { class: "admin-input-field" }
const _hoisted_24 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_25 = { class: "admin-input-field" }
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_28 = { class: "admin-input-field" }
const _hoisted_29 = { class: "admin-checkbox-input-row" }
const _hoisted_30 = { class: "admin-checkbox-input" }
const _hoisted_31 = { for: "emailCheckInput" }
const _hoisted_32 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_33 = {
  key: 0,
  class: "admin-input-field"
}
const _hoisted_34 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_35 = {
  key: 1,
  class: "admin-input-field"
}
const _hoisted_36 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_37 = { class: "admin-input-field" }
const _hoisted_38 = { class: "admin-input-field-submit" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "email-tags" }
const _hoisted_41 = { class: "add-email-tags" }
const _hoisted_42 = { class: "add-new-tags-input" }
const _hoisted_43 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_44 = { class: "add-new-tags-select" }
const _hoisted_45 = { class: "lmd-custom-select-box-top" }
const _hoisted_46 = { class: "lmd-custom-select-box-input" }
const _hoisted_47 = { class: "lmd-custom-select-box-inner" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "add-new-tags-btn" }
const _hoisted_51 = { class: "email-tags-list" }
const _hoisted_52 = { class: "email-tags-box-save" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { key: 0 }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { class: "email-tags-box-edit" }
const _hoisted_58 = { class: "email-tags-box-edit-input" }
const _hoisted_59 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_60 = { class: "add-new-tags-select" }
const _hoisted_61 = { class: "lmd-custom-select-box-top" }
const _hoisted_62 = { class: "lmd-custom-select-box-input" }
const _hoisted_63 = { class: "lmd-custom-select-box-inner" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { class: "email-tags-box-edit-btns" }
const _hoisted_67 = { class: "admin-item-list-section-in" }
const _hoisted_68 = { class: "admin-item-list-section-scroll" }
const _hoisted_69 = { class: "admin-item-list-top" }
const _hoisted_70 = { class: "admin-item-list-row" }
const _hoisted_71 = { class: "admin-item-checkbox" }
const _hoisted_72 = { class: "admin-checkbox-input" }
const _hoisted_73 = ["checked"]
const _hoisted_74 = { class: "admin-item-actions-2" }
const _hoisted_75 = { class: "admin-item-list-btm" }
const _hoisted_76 = { class: "admin-item-box-top" }
const _hoisted_77 = { class: "admin-item-list-row" }
const _hoisted_78 = { class: "admin-item-checkbox" }
const _hoisted_79 = { class: "admin-checkbox-input" }
const _hoisted_80 = ["id", "onChange", "checked"]
const _hoisted_81 = ["for"]
const _hoisted_82 = { class: "admin-item-email-template-name text-limit" }
const _hoisted_83 = { class: "admin-item-actions-2" }
const _hoisted_84 = { class: "admin-action-link" }
const _hoisted_85 = ["onClick"]
const _hoisted_86 = ["onClick"]
const _hoisted_87 = { class: "admin-item-box-btm" }
const _hoisted_88 = { class: "add-banner-image-section" }
const _hoisted_89 = { class: "email-template-form-row" }
const _hoisted_90 = { class: "add-banner-image-box" }
const _hoisted_91 = { class: "admin-input-field" }
const _hoisted_92 = ["value"]
const _hoisted_93 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_94 = { class: "admin-input-field" }
const _hoisted_95 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_96 = { class: "admin-input-field" }
const _hoisted_97 = ["value"]
const _hoisted_98 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_99 = { class: "admin-input-field" }
const _hoisted_100 = { class: "admin-checkbox-input-row" }
const _hoisted_101 = { class: "admin-checkbox-input" }
const _hoisted_102 = { for: "emailCheckInput" }
const _hoisted_103 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_104 = {
  key: 0,
  class: "admin-input-field"
}
const _hoisted_105 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_106 = {
  key: 1,
  class: "admin-input-field"
}
const _hoisted_107 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_108 = { class: "admin-input-field" }
const _hoisted_109 = { class: "admin-input-field-submit" }
const _hoisted_110 = ["disabled"]
const _hoisted_111 = { class: "email-tags" }
const _hoisted_112 = { class: "add-email-tags" }
const _hoisted_113 = { class: "add-new-tags-input" }
const _hoisted_114 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_115 = { class: "add-new-tags-select" }
const _hoisted_116 = { class: "lmd-custom-select-box-top" }
const _hoisted_117 = { class: "lmd-custom-select-box-input" }
const _hoisted_118 = { class: "lmd-custom-select-box-inner" }
const _hoisted_119 = { key: 0 }
const _hoisted_120 = ["onClick"]
const _hoisted_121 = { class: "add-new-tags-btn" }
const _hoisted_122 = { class: "email-tags-list" }
const _hoisted_123 = { class: "email-tags-box-save" }
const _hoisted_124 = ["onClick"]
const _hoisted_125 = { key: 0 }
const _hoisted_126 = ["onClick"]
const _hoisted_127 = ["onClick"]
const _hoisted_128 = { class: "email-tags-box-edit" }
const _hoisted_129 = { class: "email-tags-box-edit-input" }
const _hoisted_130 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_131 = { class: "add-new-tags-select" }
const _hoisted_132 = { class: "lmd-custom-select-box-top" }
const _hoisted_133 = { class: "lmd-custom-select-box-input" }
const _hoisted_134 = { class: "lmd-custom-select-box-inner" }
const _hoisted_135 = { key: 0 }
const _hoisted_136 = ["onClick"]
const _hoisted_137 = { class: "email-tags-box-edit-btns" }
const _hoisted_138 = { class: "admin-pagination-section" }
const _hoisted_139 = { class: "custom-row" }
const _hoisted_140 = { class: "item-show-selectbox" }
const _hoisted_141 = {
  key: 0,
  class: "admin-pagination",
  id: "paginationBox"
}
const _hoisted_142 = ["onClick"]
const _hoisted_143 = { key: 2 }
const _hoisted_144 = { class: "admin-site-footer" }
const _hoisted_145 = { class: "container" }
const _hoisted_146 = {
  class: "modal fade confirmation-popup",
  id: "deletePop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_147 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_148 = { class: "modal-content" }
const _hoisted_149 = { class: "confirmation-popup-mid" }
const _hoisted_150 = { class: "confirmation-popup-btm" }
const _hoisted_151 = {
  id: "popNoBtn",
  class: "admin-btn-outline-secondary",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_adminHeader = _resolveComponent("adminHeader")!
  const _component_adminNavigation = _resolveComponent("adminNavigation")!
  const _component_ckeditor = _resolveComponent("ckeditor")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_adminHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_adminNavigation),
        _createElementVNode("section", {
          class: "admin-right-sidebar",
          onClick: _cache[69] || (_cache[69] = 
//@ts-ignore
(...args) => (_ctx.handleOutsideClick && _ctx.handleOutsideClick(...args)))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.constants.MANAGE_EMAIL_TEMPLATE_TEXT), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "activeLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'active' }),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchView('active')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.ACTIVE_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.active), 1)
                        ], 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "inActiveLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'inActive' }),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchView('inActive')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.INACTIVE_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.inActive), 1)
                        ], 2)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        id: "seachEmailTempalteInput",
                        type: "text",
                        placeholder: "Search Email Template",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchedText) = $event)),
                        onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (
                          _ctx.fetchEmailTemplates(_ctx.activeTab),
                            _ctx.fetchCounts(_ctx.searchedText)
                        ), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.searchedText]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", {
                        id: "addBannerBtn",
                        class: "admin-btn-primary primary-icon-btn",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openEmailTemplateForm && _ctx.openEmailTemplateForm(...args)))
                      }, [
                        _cache[71] || (_cache[71] = _createElementVNode("i", { class: "add-icon" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.constants.ADD_NEW_EMAIL_TEMPLATE_TEXT), 1)
                      ])
                    ])
                  ]),
                  (_ctx.selectedEmailTemplates.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.selectedEmailTemplates.length) + " entries selected", 1),
                              _createElementVNode("button", {
                                id: "tagCloseBtn",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (
                              (_ctx.selectedEmailTemplates = []), (_ctx.selectAll = false)
                            ))
                              })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("button", {
                            class: "btn_link",
                            id: "deleteAllBtn",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#deletePop",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setDeleteMode('all')))
                          }, _toDisplayString(_ctx.constants.DELETE_ALL_BUTTON), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (_ctx.newFormOpened)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.constants.ADD_NEW_EMAIL_TEMPLATE_TEXT), 1),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("form", {
                          id: "addBannerImageForm",
                          onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitNewEmailTemplateForm && _ctx.submitNewEmailTemplateForm(...args)), ["prevent"]))
                        }, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("label", null, _toDisplayString(_ctx.constants.SELECT_USER_LABEL), 1),
                            _withDirectives(_createElementVNode("select", {
                              id: "selectUserSelectBox",
                              class: "admin-selectbox",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newEmailTemplateData.roles) = $event))
                            }, [
                              _cache[72] || (_cache[72] = _createElementVNode("option", {
                                value: "null",
                                disabled: ""
                              }, " Select user ", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (value, key) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: key,
                                  value: value.id
                                }, _toDisplayString(value.name), 9, _hoisted_21))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.newEmailTemplateData.roles]
                            ]),
                            (!_ctx.newEmailTemplateData.roles && _ctx.roleErrorMsg)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.roleErrorMsg), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("label", null, _toDisplayString(_ctx.constants.EMAIL_TITLE_LABEL), 1),
                            _withDirectives(_createElementVNode("input", {
                              id: "emailTitleInput",
                              type: "text",
                              placeholder: "Enter your email title",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newEmailTemplateData.email_title) = $event)),
                              onFocus: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.setActiveInput && _ctx.setActiveInput(...args)))
                            }, null, 544), [
                              [_vModelText, _ctx.newEmailTemplateData.email_title]
                            ]),
                            (
                            !_ctx.newEmailTemplateData.email_title &&
                            _ctx.emailTitleErrorMsg
                          )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.emailTitleErrorMsg), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("label", null, _toDisplayString(_ctx.constants.NOTIFICATION_TYPE_LABEL), 1),
                            _withDirectives(_createElementVNode("select", {
                              id: "selectNotificationTypeSelectBox",
                              class: "admin-selectbox",
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newEmailTemplateData.email_notification_type) = $event)),
                              onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.validateRoleAndNotificationType(false)))
                            }, [
                              _cache[73] || (_cache[73] = _createElementVNode("option", {
                                value: "null",
                                disabled: ""
                              }, " Select notification type ", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableNotificationTypes, (value, key) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: key,
                                  value: value.id
                                }, _toDisplayString(value.title), 9, _hoisted_26))
                              }), 128))
                            ], 544), [
                              [_vModelSelect, _ctx.newEmailTemplateData.email_notification_type]
                            ]),
                            (_ctx.emailNotificationTypeErrorMsg)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.emailNotificationTypeErrorMsg), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("label", null, _toDisplayString(_ctx.constants.EMAIL_RECEIVER_TYPE_LABEL), 1),
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _withDirectives(_createElementVNode("input", {
                                  name: "cssCheckbox",
                                  id: "emailCheckInput",
                                  type: "checkbox",
                                  class: "css-checkbox",
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newEmailTemplateData.emailChecked) = $event))
                                }, null, 512), [
                                  [_vModelCheckbox, _ctx.newEmailTemplateData.emailChecked]
                                ]),
                                _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.constants.EMAIL_LABEL), 1)
                              ])
                            ]),
                            (
                            !_ctx.newEmailTemplateData.websiteChecked &&
                            !_ctx.newEmailTemplateData.emailChecked &&
                            _ctx.notificationReceiverTypeErrorMsg
                          )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.notificationReceiverTypeErrorMsg), 1))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.newEmailTemplateData.websiteChecked)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                _createElementVNode("label", null, _toDisplayString(_ctx.constants.WEB_MOBILE_MESSAGE_LABEL), 1),
                                _createVNode(_component_ckeditor, {
                                  placeholder: "Web or mobile message",
                                  class: "text-editer",
                                  id: "servicesPgSubHdInput",
                                  editor: _ctx.editor,
                                  modelValue: _ctx.newEmailTemplateData.web_or_mobile_content,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newEmailTemplateData.web_or_mobile_content) = $event)),
                                  config: _ctx.Config
                                }, null, 8, ["editor", "modelValue", "config"]),
                                (
                            !_ctx.newEmailTemplateData.web_or_mobile_content &&
                            _ctx.webOrMobileContentErrorMsg
                          )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.webOrMobileContentErrorMsg), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.newEmailTemplateData.emailChecked)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                _createElementVNode("label", null, _toDisplayString(_ctx.constants.EMAIL_MESSAGE_LABEL), 1),
                                _createVNode(_component_ckeditor, {
                                  placeholder: "Email message",
                                  class: "text-editer",
                                  id: "servicesPgSubHdInput",
                                  editor: _ctx.editor,
                                  modelValue: _ctx.newEmailTemplateData.email_content,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newEmailTemplateData.email_content) = $event)),
                                  config: _ctx.Config,
                                  onReady: _ctx.onNewEditorReady
                                }, null, 8, ["editor", "modelValue", "config", "onReady"]),
                                (_ctx.emailContentErrorMsg)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.emailContentErrorMsg), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("label", null, _toDisplayString(_ctx.constants.ACTIVE_INACTIVE_LABEL), 1),
                            _createElementVNode("div", {
                              class: "active-inactive-radio",
                              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.toggleStatus(_ctx.newEmailTemplateData)))
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                id: "ActiveInput",
                                type: "radio",
                                name: "foo",
                                class: "active-radio",
                                value: 1,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newEmailTemplateData.status) = $event))
                              }, null, 512), [
                                [_vModelRadio, _ctx.newEmailTemplateData.status]
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                id: "InactiveInput",
                                type: "radio",
                                name: "foo",
                                class: "inactive-radio",
                                value: 0,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newEmailTemplateData.status) = $event))
                              }, null, 512), [
                                [_vModelRadio, _ctx.newEmailTemplateData.status]
                              ]),
                              _cache[74] || (_cache[74] = _createElementVNode("div", { class: "active-inactive-radio-img" }, null, -1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("button", {
                              id: "bnrPgSubmitBtn",
                              class: "admin-btn-outline-primary",
                              type: "submit",
                              disabled: _ctx.isFormSubmitting
                            }, _toDisplayString(_ctx.constants.SUBMIT_BUTTON), 9, _hoisted_39),
                            _createElementVNode("button", {
                              id: "bnrPgCancelBtn",
                              class: "admin-btn-outline-secondary",
                              onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.cancelNewEmailTemplateForm && _ctx.cancelNewEmailTemplateForm(...args))),
                              type: "button"
                            }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                          ])
                        ], 32)
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              placeholder: "Add a new tag",
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.newTag.key) = $event)),
                              onFocus: _cache[21] || (_cache[21] = ($event: any) => {
                            _ctx.isListOpenedForEditTag = false;
                            _ctx.isListOpenedForNewTag = false;
                            _ctx.emailTags = _ctx.emailTags.map((tag) => ({
                              ...tag,
                              editing: false,
                            }));
                          })
                            }, null, 544), [
                              [_vModelText, _ctx.newTag.key]
                            ]),
                            (!_ctx.newTag.key && _ctx.newTagErrors.keyError)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_ctx.newTagErrors.keyError), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["lmd-custom-select-box", {
                            'lmd-custom-select-box-show': _ctx.isListOpenedForNewTag,
                          }])
                            }, [
                              _createElementVNode("div", _hoisted_45, [
                                _createElementVNode("div", _hoisted_46, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.newTag.value) = $event)),
                                    placeholder: "Enter or select value",
                                    onFocus: _cache[23] || (_cache[23] = ($event: any) => {
                                  _ctx.isListOpenedForEditTag = false;
                                  _ctx.isListOpenedForNewTag = false;
                                  _ctx.emailTags = _ctx.emailTags.map((tag) => ({
                                    ...tag,
                                    editing: false,
                                  }));
                                }),
                                    onInput: _cache[24] || (_cache[24] = ($event: any) => (_ctx.newTag.referenced_key = null))
                                  }, null, 544), [
                                    [_vModelText, _ctx.newTag.value]
                                  ])
                                ]),
                                _createElementVNode("button", {
                                  onClick: _cache[25] || (_cache[25] = ($event: any) => {
                                _ctx.openAndCloseList(false);
                                _ctx.isListOpenedForEditTag = false;
                                _ctx.emailTags = _ctx.emailTags.map((tag) => ({
                                  ...tag,
                                  editing: false,
                                }));
                              }),
                                  class: "lmd-custom-select-box-btn"
                                })
                              ]),
                              _createElementVNode("div", _hoisted_47, [
                                _createElementVNode("ul", null, [
                                  (_ctx.emailTags.length === 0)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_48, " No data "))
                                    : _createCommentVNode("", true),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailTags, (tag) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: tag.id,
                                      onClick: ($event: any) => (_ctx.selectKey(tag.id, false))
                                    }, _toDisplayString(tag.key), 9, _hoisted_49))
                                  }), 128))
                                ])
                              ])
                            ], 2)
                          ]),
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("button", {
                              class: "admin-btn-outline-primary",
                              id: "addEmailTagBtn",
                              onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.addFilterKey && _ctx.addFilterKey(...args)))
                            }, _toDisplayString(_ctx.constants.ADD_BUTTON), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailTags, (tag) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: tag.id,
                              class: _normalizeClass(["email-tags-box", { 'tags-editable': tag.editing }])
                            }, [
                              _createElementVNode("div", _hoisted_52, [
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (_ctx.insertTagIntoEditor(tag.key)),
                                  style: {"cursor":"pointer"}
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(tag.key), 1),
                                  (!tag.is_predefined && tag.effective_value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_54, " : " + _toDisplayString(tag.effective_value), 1))
                                    : _createCommentVNode("", true)
                                ], 8, _hoisted_53),
                                (!tag.is_predefined)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "tags-edit-btn",
                                      onClick: ($event: any) => {
                              _ctx.startEditTag(tag);
                              _ctx.newTag.key = '';
                              _ctx.newTag.value = null;
                              _ctx.newTag.referenced_key = null;
                              _ctx.isListOpenedForNewTag = false;
                            }
                                    }, null, 8, _hoisted_55))
                                  : _createCommentVNode("", true),
                                (!tag.is_predefined)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      class: "tags-delete-btn",
                                      onClick: ($event: any) => (_ctx.deleteTag(tag.id))
                                    }, null, 8, _hoisted_56))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("div", _hoisted_58, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    placeholder: "Enter your tag",
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.editTag.key) = $event)),
                                    onFocus: _cache[28] || (_cache[28] = ($event: any) => {
                                _ctx.isListOpenedForNewTag = false;
                                _ctx.newTag.key = '';
                                _ctx.newTag.value = null;
                                _ctx.newTag.referenced_key = null;
                              })
                                  }, null, 544), [
                                    [_vModelText, _ctx.editTag.key]
                                  ]),
                                  (!_ctx.editTag.key && _ctx.editTagErrors.keyError)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(_ctx.editTagErrors.keyError), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_60, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["lmd-custom-select-box", {
                                'lmd-custom-select-box-show':
                                  _ctx.isListOpenedForEditTag,
                              }])
                                  }, [
                                    _createElementVNode("div", _hoisted_61, [
                                      _createElementVNode("div", _hoisted_62, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.editTag.value) = $event)),
                                          placeholder: "Enter or select value",
                                          onFocus: _cache[30] || (_cache[30] = ($event: any) => (_ctx.isListOpenedForEditTag = false)),
                                          onInput: _cache[31] || (_cache[31] = ($event: any) => (_ctx.editTag.referenced_key = null))
                                        }, null, 544), [
                                          [_vModelText, _ctx.editTag.value]
                                        ])
                                      ]),
                                      _createElementVNode("button", {
                                        onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.openAndCloseList(true))),
                                        class: "lmd-custom-select-box-btn"
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_63, [
                                      _createElementVNode("ul", null, [
                                        (_ctx.emailTags.length === 0)
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_64, " No data "))
                                          : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailTags, (tag) => {
                                          return (_openBlock(), _createElementBlock("li", {
                                            key: tag.id,
                                            onClick: ($event: any) => (_ctx.selectKey(tag.id, true))
                                          }, _toDisplayString(tag.key), 9, _hoisted_65))
                                        }), 128))
                                      ])
                                    ])
                                  ], 2)
                                ]),
                                _createElementVNode("div", _hoisted_66, [
                                  _createElementVNode("button", {
                                    class: "tags-edit-save-btn",
                                    id: "saveEmailTagEditBtn",
                                    onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.saveTagEdit()))
                                  }),
                                  _createElementVNode("button", {
                                    class: "tags-edit-delete-btn",
                                    id: "deleteEmailTagEditBtn",
                                    onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.cancelTagEdit()))
                                  })
                                ])
                              ])
                            ], 2))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.emailTemplateData.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass([
                'admin-item-list-section email-template-section',
                { 'show-edit-item-outer': _ctx.editFormOpened },
              ])
                }, [
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("div", _hoisted_70, [
                          _createElementVNode("div", _hoisted_71, [
                            _createElementVNode("div", _hoisted_72, [
                              _createElementVNode("input", {
                                name: "cssCheckbox",
                                id: "allCheckInput",
                                type: "checkbox",
                                class: "css-checkbox",
                                onChange: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args))),
                                checked: _ctx.selectAll === true
                              }, null, 40, _hoisted_73),
                              _cache[75] || (_cache[75] = _createElementVNode("label", { for: "allCheckInput" }, null, -1))
                            ])
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-email-template-name text-limit",
                            onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.toggleSort('email_title'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.TITLE_LABEL) + " ", 1),
                            (_ctx.sortBy === 'email_title' || _ctx.sortBy === '-email_title')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-email_title' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.constants.ACTIONS_LABEL), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_75, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailTemplateData, (emailTemplate, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass([
                        'admin-item-box',
                        { 'show-edit-item': emailTemplate.editing },
                      ]),
                            key: emailTemplate.id
                          }, [
                            _createElementVNode("div", _hoisted_76, [
                              _createElementVNode("div", _hoisted_77, [
                                _createElementVNode("div", _hoisted_78, [
                                  _createElementVNode("div", _hoisted_79, [
                                    _createElementVNode("input", {
                                      name: "cssCheckbox",
                                      id: 'checkItemOneInput' + emailTemplate.id,
                                      type: "checkbox",
                                      class: "css-checkbox",
                                      onChange: ($event: any) => (
                                  _ctx.toggleEmailTemplateSelection(emailTemplate.id)
                                ),
                                      checked: 
                                  _ctx.selectedEmailTemplates.includes(
                                    emailTemplate.id
                                  )
                                
                                    }, null, 40, _hoisted_80),
                                    _createElementVNode("label", {
                                      for: 'checkItemOneInput' + emailTemplate.id
                                    }, null, 8, _hoisted_81)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_82, _toDisplayString(emailTemplate.email_title), 1),
                                _createElementVNode("div", _hoisted_83, [
                                  _createElementVNode("ul", _hoisted_84, [
                                    _createElementVNode("li", null, [
                                      _createElementVNode("button", {
                                        id: "bnrPgEditBtn",
                                        onClick: ($event: any) => (_ctx.editEmailTemplate(index))
                                      }, _toDisplayString(_ctx.constants.EDIT_BUTTON), 9, _hoisted_85)
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createElementVNode("button", {
                                        id: "bnrPgDeleteBtn",
                                        "data-bs-toggle": "modal",
                                        "data-bs-target": "#deletePop",
                                        onClick: ($event: any) => (
                                    _ctx.setDeleteMode('single', emailTemplate.id),
                                      (_ctx.newFormOpened = false),
                                      _ctx.cancelEditEmailTemplateForm()
                                  )
                                      }, _toDisplayString(_ctx.constants.DELETE_BUTTON), 9, _hoisted_86)
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_87, [
                              _createElementVNode("div", _hoisted_88, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.constants.EDIT_EMAIL_TEMPLATE_TEXT), 1),
                                _createElementVNode("div", _hoisted_89, [
                                  _createElementVNode("div", _hoisted_90, [
                                    _createElementVNode("form", {
                                      id: "editBannerImageForm",
                                      onSubmit: _cache[49] || (_cache[49] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitEditEmailTemplateForm && _ctx.submitEditEmailTemplateForm(...args)), ["prevent"]))
                                    }, [
                                      _createElementVNode("div", _hoisted_91, [
                                        _createElementVNode("label", null, _toDisplayString(_ctx.constants.SELECT_USER_LABEL), 1),
                                        _withDirectives(_createElementVNode("select", {
                                          id: "selectUserSelectBox",
                                          class: "admin-selectbox",
                                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.editEmailTemplateData.roles) = $event))
                                        }, [
                                          _cache[76] || (_cache[76] = _createElementVNode("option", {
                                            value: "null",
                                            disabled: ""
                                          }, " Select user ", -1)),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (value, key) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              key: key,
                                              value: value.id
                                            }, _toDisplayString(value.name), 9, _hoisted_92))
                                          }), 128))
                                        ], 512), [
                                          [_vModelSelect, _ctx.editEmailTemplateData.roles]
                                        ]),
                                        (
                                      !_ctx.editEmailTemplateData.roles &&
                                      _ctx.editRoleErrorMsg
                                    )
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_93, _toDisplayString(_ctx.editRoleErrorMsg), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_94, [
                                        _createElementVNode("label", null, _toDisplayString(_ctx.constants.EMAIL_TITLE_LABEL), 1),
                                        _withDirectives(_createElementVNode("input", {
                                          id: "emailTitleInput",
                                          type: "text",
                                          placeholder: "Enter your email title",
                                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.editEmailTemplateData.email_title) = $event)),
                                          onFocus: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.setActiveInput && _ctx.setActiveInput(...args)))
                                        }, null, 544), [
                                          [_vModelText, _ctx.editEmailTemplateData.email_title]
                                        ]),
                                        (
                                      !_ctx.editEmailTemplateData.email_title &&
                                      _ctx.editEmailTitleErrorMsg
                                    )
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_95, _toDisplayString(_ctx.editEmailTitleErrorMsg), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_96, [
                                        _createElementVNode("label", null, _toDisplayString(_ctx.constants.NOTIFICATION_TYPE_LABEL), 1),
                                        _withDirectives(_createElementVNode("select", {
                                          id: "selectNotificationTypeSelectBox",
                                          class: "admin-selectbox",
                                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((
                                      _ctx.editEmailTemplateData.email_notification_type
                                    ) = $event)),
                                          onChange: _cache[41] || (_cache[41] = ($event: any) => (_ctx.validateRoleAndNotificationType(true)))
                                        }, [
                                          _cache[77] || (_cache[77] = _createElementVNode("option", {
                                            value: "null",
                                            disabled: ""
                                          }, " Select notification type ", -1)),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notification_types, (value, key) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              key: key,
                                              value: value.id
                                            }, _toDisplayString(value.title), 9, _hoisted_97))
                                          }), 128))
                                        ], 544), [
                                          [_vModelSelect, 
                                      _ctx.editEmailTemplateData.email_notification_type
                                    ]
                                        ]),
                                        (_ctx.editEmailNotificationTypeErrorMsg)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_98, _toDisplayString(_ctx.editEmailNotificationTypeErrorMsg), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_99, [
                                        _createElementVNode("label", null, _toDisplayString(_ctx.constants.EMAIL_RECEIVER_TYPE_LABEL), 1),
                                        _createElementVNode("div", _hoisted_100, [
                                          _createElementVNode("div", _hoisted_101, [
                                            _withDirectives(_createElementVNode("input", {
                                              name: "cssCheckbox",
                                              id: "emailCheckInput",
                                              type: "checkbox",
                                              class: "css-checkbox",
                                              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((
                                          _ctx.editEmailTemplateData.emailChecked
                                        ) = $event))
                                            }, null, 512), [
                                              [_vModelCheckbox, 
                                          _ctx.editEmailTemplateData.emailChecked
                                        ]
                                            ]),
                                            _createElementVNode("label", _hoisted_102, _toDisplayString(_ctx.constants.EMAIL_LABEL), 1)
                                          ])
                                        ]),
                                        (
                                      !_ctx.editEmailTemplateData.websiteChecked &&
                                      !_ctx.editEmailTemplateData.emailChecked &&
                                      _ctx.editNotificationReceiverTypeErrorMsg
                                    )
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_103, _toDisplayString(_ctx.editNotificationReceiverTypeErrorMsg), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      (_ctx.editEmailTemplateData.websiteChecked)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                            _createElementVNode("label", null, _toDisplayString(_ctx.constants.WEB_MOBILE_MESSAGE_LABEL), 1),
                                            _createVNode(_component_ckeditor, {
                                              placeholder: "Web or mobile message",
                                              class: "text-editer",
                                              id: "servicesPgSubHdInput",
                                              editor: _ctx.editor,
                                              modelValue: 
                                      _ctx.editEmailTemplateData.web_or_mobile_content
                                    ,
                                              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((
                                      _ctx.editEmailTemplateData.web_or_mobile_content
                                    ) = $event)),
                                              config: _ctx.Config
                                            }, null, 8, ["editor", "modelValue", "config"]),
                                            (
                                      !_ctx.editEmailTemplateData.web_or_mobile_content &&
                                      _ctx.editWebOrMobileContentErrorMsg
                                    )
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_105, _toDisplayString(_ctx.editWebOrMobileContentErrorMsg), 1))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.editEmailTemplateData.emailChecked)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                            _createElementVNode("label", null, _toDisplayString(_ctx.constants.EMAIL_MESSAGE_LABEL), 1),
                                            _createVNode(_component_ckeditor, {
                                              placeholder: "Email message",
                                              class: "text-editer",
                                              id: "servicesPgSubHdInput",
                                              editor: _ctx.editor,
                                              modelValue: 
                                      _ctx.editEmailTemplateData.email_content
                                    ,
                                              "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((
                                      _ctx.editEmailTemplateData.email_content
                                    ) = $event)),
                                              config: _ctx.Config,
                                              onReady: _ctx.onEditEditorReady
                                            }, null, 8, ["editor", "modelValue", "config", "onReady"]),
                                            (_ctx.editEmailContentErrorMsg)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_107, _toDisplayString(_ctx.editEmailContentErrorMsg), 1))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_108, [
                                        _createElementVNode("label", null, _toDisplayString(_ctx.constants.ACTIVE_INACTIVE_LABEL), 1),
                                        _createElementVNode("div", {
                                          class: "active-inactive-radio",
                                          onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.toggleStatus(_ctx.editEmailTemplateData)))
                                        }, [
                                          _withDirectives(_createElementVNode("input", {
                                            id: "ActiveInput",
                                            type: "radio",
                                            name: "foo",
                                            class: "active-radio",
                                            value: 1,
                                            "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.editEmailTemplateData.status) = $event))
                                          }, null, 512), [
                                            [_vModelRadio, _ctx.editEmailTemplateData.status]
                                          ]),
                                          _withDirectives(_createElementVNode("input", {
                                            id: "InactiveInput",
                                            type: "radio",
                                            name: "foo",
                                            class: "inactive-radio",
                                            value: 0,
                                            "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.editEmailTemplateData.status) = $event))
                                          }, null, 512), [
                                            [_vModelRadio, _ctx.editEmailTemplateData.status]
                                          ]),
                                          _cache[78] || (_cache[78] = _createElementVNode("div", { class: "active-inactive-radio-img" }, null, -1))
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_109, [
                                        _createElementVNode("button", {
                                          id: "bnrPgSubmitBtn",
                                          class: "admin-btn-outline-primary",
                                          type: "submit",
                                          disabled: _ctx.isFormSubmitting
                                        }, _toDisplayString(_ctx.constants.SUBMIT_BUTTON), 9, _hoisted_110),
                                        _createElementVNode("button", {
                                          id: "bnrPgCancelBtn",
                                          class: "admin-btn-outline-secondary",
                                          type: "button",
                                          onClick: _cache[48] || (_cache[48] = 
//@ts-ignore
(...args) => (_ctx.cancelEditEmailTemplateForm && _ctx.cancelEditEmailTemplateForm(...args)))
                                        }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                                      ])
                                    ], 32)
                                  ]),
                                  _createElementVNode("div", _hoisted_111, [
                                    _createElementVNode("div", _hoisted_112, [
                                      _createElementVNode("div", _hoisted_113, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          placeholder: "Add a new tag",
                                          "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.newTag.key) = $event)),
                                          onFocus: _cache[51] || (_cache[51] = ($event: any) => {
                                      _ctx.isListOpenedForEditTag = false;
                                      _ctx.isListOpenedForNewTag = false;
                                      _ctx.emailTags = _ctx.emailTags.map((tag) => ({
                                        ...tag,
                                        editing: false,
                                      }));
                                    })
                                        }, null, 544), [
                                          [_vModelText, _ctx.newTag.key]
                                        ]),
                                        (!_ctx.newTag.key && _ctx.newTagErrors.keyError)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_114, _toDisplayString(_ctx.newTagErrors.keyError), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_115, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["lmd-custom-select-box", {
                                      'lmd-custom-select-box-show':
                                        _ctx.isListOpenedForNewTag,
                                    }])
                                        }, [
                                          _createElementVNode("div", _hoisted_116, [
                                            _createElementVNode("div", _hoisted_117, [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.newTag.value) = $event)),
                                                placeholder: "Enter or select value",
                                                onFocus: _cache[53] || (_cache[53] = ($event: any) => {
                                            _ctx.isListOpenedForEditTag = false;
                                            _ctx.isListOpenedForNewTag = false;
                                            _ctx.emailTags = _ctx.emailTags.map(
                                              (tag) => ({
                                                ...tag,
                                                editing: false,
                                              })
                                            );
                                          }),
                                                onInput: _cache[54] || (_cache[54] = ($event: any) => (_ctx.newTag.referenced_key = null))
                                              }, null, 544), [
                                                [_vModelText, _ctx.newTag.value]
                                              ])
                                            ]),
                                            _createElementVNode("button", {
                                              onClick: _cache[55] || (_cache[55] = ($event: any) => {
                                          _ctx.openAndCloseList(false);
                                          _ctx.isListOpenedForEditTag = false;
                                          _ctx.emailTags = _ctx.emailTags.map((tag) => ({
                                            ...tag,
                                            editing: false,
                                          }));
                                        }),
                                              class: "lmd-custom-select-box-btn"
                                            })
                                          ]),
                                          _createElementVNode("div", _hoisted_118, [
                                            _createElementVNode("ul", null, [
                                              (_ctx.emailTags.length === 0)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_119, " No data "))
                                                : _createCommentVNode("", true),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailTags, (tag) => {
                                                return (_openBlock(), _createElementBlock("li", {
                                                  key: tag.id,
                                                  onClick: ($event: any) => (_ctx.selectKey(tag.id, false))
                                                }, _toDisplayString(tag.key), 9, _hoisted_120))
                                              }), 128))
                                            ])
                                          ])
                                        ], 2)
                                      ]),
                                      _createElementVNode("div", _hoisted_121, [
                                        _createElementVNode("button", {
                                          class: "admin-btn-outline-primary",
                                          id: "addEmailTagBtn",
                                          onClick: _cache[56] || (_cache[56] = 
//@ts-ignore
(...args) => (_ctx.addFilterKey && _ctx.addFilterKey(...args)))
                                        }, _toDisplayString(_ctx.constants.ADD_BUTTON), 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_122, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailTags, (tag) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: tag.id,
                                          class: _normalizeClass(["email-tags-box", { 'tags-editable': tag.editing }])
                                        }, [
                                          _createElementVNode("div", _hoisted_123, [
                                            _createElementVNode("div", {
                                              onClick: ($event: any) => (_ctx.insertTagIntoEditor(tag.key)),
                                              style: {"cursor":"pointer"}
                                            }, [
                                              _createElementVNode("span", null, _toDisplayString(tag.key), 1),
                                              (
                                        !tag.is_predefined &&
                                        tag.effective_value
                                      )
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_125, " : " + _toDisplayString(tag.effective_value), 1))
                                                : _createCommentVNode("", true)
                                            ], 8, _hoisted_124),
                                            (!tag.is_predefined)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 0,
                                                  class: "tags-edit-btn",
                                                  onClick: ($event: any) => {
                                        _ctx.startEditTag(tag);
                                        _ctx.newTag.key = '';
                                        _ctx.newTag.value = null;
                                        _ctx.newTag.referenced_key = null;
                                        _ctx.isListOpenedForNewTag = false;
                                      }
                                                }, null, 8, _hoisted_126))
                                              : _createCommentVNode("", true),
                                            (!tag.is_predefined)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 1,
                                                  class: "tags-delete-btn",
                                                  onClick: ($event: any) => (_ctx.deleteTag(tag.id))
                                                }, null, 8, _hoisted_127))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("div", _hoisted_128, [
                                            _createElementVNode("div", _hoisted_129, [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                placeholder: "Enter your tag",
                                                "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.editTag.key) = $event)),
                                                onFocus: _cache[58] || (_cache[58] = ($event: any) => {
                                          _ctx.isListOpenedForNewTag = false;
                                          _ctx.newTag.key = '';
                                          _ctx.newTag.value = null;
                                          _ctx.newTag.referenced_key = null;
                                        })
                                              }, null, 544), [
                                                [_vModelText, _ctx.editTag.key]
                                              ]),
                                              (
                                          !_ctx.editTag.key && _ctx.editTagErrors.keyError
                                        )
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_130, _toDisplayString(_ctx.editTagErrors.keyError), 1))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_131, [
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["lmd-custom-select-box", {
                                          'lmd-custom-select-box-show':
                                            _ctx.isListOpenedForEditTag,
                                        }])
                                              }, [
                                                _createElementVNode("div", _hoisted_132, [
                                                  _createElementVNode("div", _hoisted_133, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "text",
                                                      "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.editTag.value) = $event)),
                                                      placeholder: "Enter or select value",
                                                      onFocus: _cache[60] || (_cache[60] = ($event: any) => (
                                                _ctx.isListOpenedForEditTag = false
                                              )),
                                                      onInput: _cache[61] || (_cache[61] = ($event: any) => (
                                                _ctx.editTag.referenced_key = null
                                              ))
                                                    }, null, 544), [
                                                      [_vModelText, _ctx.editTag.value]
                                                    ])
                                                  ]),
                                                  _createElementVNode("button", {
                                                    onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.openAndCloseList(true))),
                                                    class: "lmd-custom-select-box-btn"
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_134, [
                                                  _createElementVNode("ul", null, [
                                                    (_ctx.emailTags.length === 0)
                                                      ? (_openBlock(), _createElementBlock("li", _hoisted_135, " No data "))
                                                      : _createCommentVNode("", true),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailTags, (tag) => {
                                                      return (_openBlock(), _createElementBlock("li", {
                                                        key: tag.id,
                                                        onClick: ($event: any) => (_ctx.selectKey(tag.id, true))
                                                      }, _toDisplayString(tag.key), 9, _hoisted_136))
                                                    }), 128))
                                                  ])
                                                ])
                                              ], 2)
                                            ]),
                                            _createElementVNode("div", _hoisted_137, [
                                              _createElementVNode("button", {
                                                class: "tags-edit-save-btn",
                                                id: "saveEmailTagEditBtn",
                                                onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.saveTagEdit()))
                                              }),
                                              _createElementVNode("button", {
                                                class: "tags-edit-delete-btn",
                                                id: "deleteEmailTagEditBtn",
                                                onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.cancelTagEdit()))
                                              })
                                            ])
                                          ])
                                        ], 2))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ], 2))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_138, [
                    _createElementVNode("div", _hoisted_139, [
                      _createElementVNode("div", _hoisted_140, [
                        _withDirectives(_createElementVNode("select", {
                          id: "paginationSelectBox",
                          "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.limit) = $event)),
                          onChange: _cache[66] || (_cache[66] = 
//@ts-ignore
(...args) => (_ctx.handleLimitChange && _ctx.handleLimitChange(...args)))
                        }, [...(_cache[79] || (_cache[79] = [
                          _createElementVNode("option", { value: "10" }, "10", -1),
                          _createElementVNode("option", { value: "20" }, "20", -1),
                          _createElementVNode("option", { value: "50" }, "50", -1),
                          _createElementVNode("option", { value: "100" }, "100", -1)
                        ]))], 544), [
                          [_vModelSelect, _ctx.limit]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.ENTRIES_PER_PAGE_LABEL), 1)
                      ]),
                      (_ctx.totalPages > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                            _createElementVNode("ul", null, [
                              (_ctx.currentPage !== 1)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 0,
                                    onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.changePage(_ctx.currentPage - 1)))
                                  }, [...(_cache[80] || (_cache[80] = [
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "pagination-previous"
                                    }, null, -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                              (_ctx.totalPages != 1)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.visiblePages, (page) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: page,
                                      onClick: ($event: any) => (_ctx.changePage(page))
                                    }, [
                                      _createElementVNode("a", {
                                        href: "#",
                                        class: _normalizeClass({ active: _ctx.currentPage === page })
                                      }, _toDisplayString(page), 3)
                                    ], 8, _hoisted_142))
                                  }), 128))
                                : _createCommentVNode("", true),
                              (_ctx.currentPage !== _ctx.totalPages)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 2,
                                    onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.changePage(_ctx.currentPage + 1)))
                                  }, [...(_cache[81] || (_cache[81] = [
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "pagination-next"
                                    }, null, -1)
                                  ]))]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2))
              : (_openBlock(), _createElementBlock("div", _hoisted_143, [...(_cache[82] || (_cache[82] = [
                  _createElementVNode("p", null, "No data to display", -1)
                ]))]))
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_144, [
      _createElementVNode("div", _hoisted_145, _toDisplayString(_ctx.constants.COPYRIGHT_TEXT), 1)
    ]),
    _createElementVNode("div", _hoisted_146, [
      _createElementVNode("div", _hoisted_147, [
        _createElementVNode("div", _hoisted_148, [
          _cache[83] || (_cache[83] = _createElementVNode("div", { class: "confirmation-popup-icon" }, [
            _createElementVNode("i", null, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_149, [
            _createElementVNode("p", null, _toDisplayString(_ctx.constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT), 1)
          ]),
          _createElementVNode("div", _hoisted_150, [
            _createElementVNode("button", _hoisted_151, _toDisplayString(_ctx.constants.NO_BUTTON), 1),
            _createElementVNode("button", {
              id: "popYesBtn",
              class: "admin-btn-outline-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[70] || (_cache[70] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
            }, _toDisplayString(_ctx.constants.YES_BUTTON), 1)
          ])
        ])
      ])
    ])
  ]))
}